import { WZUtils } from "../common/globals";

const WZSale = window._WZSale_ || {}


export const PRE_END = WZSale.preEnd > 0 ? +WZSale.preEnd : +new Date(2018, 10, 10, 0, 0, 0 )
// export const LAST_BEGIN = +new Date(2018, 9, 11, 0, 0, 0 )
export const LAST_BEGIN = WZSale.lastBegin > 0 ? +WZSale.lastBegin : +new Date(2018, 10, 11, 0, 0, 0 )
export const LAST_END = WZSale.lastEnd > 0 ? +WZSale.lastEnd : +new Date(2018, 10, 12, 0, 0, 0)

export const HOST_NAME = location.hostname

const PYDP888_COM = 'pydp888.com'
const IWANGZHE_COM = 'iwangzhe.com'
export const ENV_MODE = /dev\./.test(HOST_NAME) ? 'dev' : /test\./.test(HOST_NAME) ? 'test' : 'prd'

export const HOST_STATIC = `staticcdn-${ENV_MODE}.${PYDP888_COM}`
export const HOST_API = ENV_MODE === 'dev' ? `api-dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `api-test.${IWANGZHE_COM}` : `api.${IWANGZHE_COM}`
export const HOST_WEB = ENV_MODE === 'dev' ? `dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `test.${IWANGZHE_COM}` : `${IWANGZHE_COM}`
export const HOST_BBS = ENV_MODE === 'dev' ? `bbs-dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `bbs-test.${IWANGZHE_COM}` : `bbs.${IWANGZHE_COM}`

export const DIR_RES = `https://${HOST_STATIC}/award/kline/sale/201811/`
export const DIR_CSS = `${DIR_RES}css/`
export const DIR_IMG = `https://${HOST_STATIC}/award/kline/sale/img/201811/`

export const STATUS_WAIT = 0
export const STATUS_SELLING = 1
export const STATUS_ENDED = 2


export const PRE_BUY_NONE = 0
export const PRE_BUY_OK = 1
export const PRE_BUY_EXPIRED = 2

export const LAST_BUY_NONE = 0
export const LAST_BUY_OK = 1

// ERROR
export const ERR_GOODS_404 = 601
export const ERR_CANT_BUY = 602
export const ERR_PRE_IS_ENDED = 603
export const ERR_SALE_NOT_BEGIN = 604
export const ERR_SALE_IS_ENDED = 605
export const ERR_PAYED_PRE = 606  // 已支付过定金
export const ERR_PAYED_LAST = 607   // 已支付过尾款
export const ERR_NEED_LOGIN = 608   // 未登录
export const ERR_NEED_MOBILE = 609   // 未登录

WZUtils.setErrorMsg(ERR_GOODS_404, '没有该商品或已下架')
WZUtils.setErrorMsg(ERR_CANT_BUY, '你无法购买该商品')
WZUtils.setErrorMsg(ERR_PRE_IS_ENDED, '预付定金已结束！')
WZUtils.setErrorMsg(ERR_SALE_NOT_BEGIN, '尾款支付时间还没到！')
WZUtils.setErrorMsg(ERR_SALE_IS_ENDED, '非常感谢您的关注和支持，本次双11活动已结束，如果需要了解更多斗K！')
WZUtils.setErrorMsg(ERR_PAYED_PRE, '你已支付过其它款的定金！')
WZUtils.setErrorMsg(ERR_PAYED_LAST, '每人仅限购买一种套餐或礼包！')
WZUtils.setErrorMsg(ERR_NEED_LOGIN, '需要先登录才可购买！')
WZUtils.setErrorMsg(ERR_NEED_MOBILE, '需要先绑定手机号才可购买！')
